import { BaseViewStore } from 'core/stores';
import { action, observable } from "mobx";
import { FacilityOrderTemplateItemService } from "application/facility-order/services";
import { PickTicketDetailService } from "application/pick-ticket/services";
import _ from "lodash";

class PickTicketDetailNewFlowItemDetailsModalStore extends BaseViewStore {
    @observable accessor items;
    @observable accessor isSendSeparately = false;
    @observable accessor disabled = false;
    @observable accessor showWarningMessage = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.pickTicketDetail = this.modalParams.data.pickTicketDetail;
        this.facilityOrder = this.modalParams.data.facilityOrder;
        this.pickTicketHeader = this.modalParams.data.pickTicketHeader;
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.pickTicketDetailService = new PickTicketDetailService(rootStore.application.baasic.apiClient);
        this.fetch([this.initialize()]);

        this.warningMessage = (this.pickTicketHeader.pickTicketHeaderStatus && this.pickTicketHeader.pickTicketHeaderStatus.abrv === "completed") ?
        "Purchasing is complete. Don't make changes to the facility order." :
        (this.pickTicketHeader.pickTicketHeaderStatus && this.pickTicketHeader.pickTicketHeaderStatus.abrv === "in-progress") ?
        "Purchasing is in progress. Don't make changes to the facility order." :
        this.facilityOrder.sendOrder ? "Billing is in progress. Any changes made must be reported to the biller." : null;
    }

    @action
    async initialize() {
        this.items = _.map(this.pickTicketDetail.facilityOrderTemplateItems, (i) => { return { ...i, isUpdating: false  }; });
    }

    @action.bound
    setSendSeparately(value) {
        this.showWarningMessage = true;
        this.isSendSeparately = value;
    }

    @action.bound
    editSendSeparatelyQuantity(index, value) {
        if (value <= this.items[index].orderQuantity) {
            this.items[index].sendSeparatelyQty = parseInt(value);
            this.items[index].isUpdating = true;
        }
    }

    @action.bound
    async saveChanges() {
        this.disabled = true;
        try {
            if(this.items.some(x=> x.isUpdating)){
                await this.facilityOrderTemplateItemService.batchUpdateSendSeparatelyQty(this.items.filter(x=>x.isUpdating));
                _.each(this.items, (item) => {
                    this.pickTicketDetail.facilityOrderTemplateItems.find(i => i.id === item.id).sendSeparatelyQty = item.sendSeparatelyQty;
                });

                this.pickTicketDetail.sendSeparatelyQty = this.pickTicketDetail.facilityOrderTemplateItems.reduce((acc, item) => acc + (item.sendSeparatelyQty || 0), 0);
                await this.pickTicketDetailService.updateSendSeparatelyQty(this.pickTicketDetail);
                this.pickTicketDetail.totalQty = (this.pickTicketDetail.qty || 0) - this.pickTicketDetail.sendSeparatelyQty; 
            }
            this.rootStore.notificationStore.success('LIST_LAYOUT.SUCCESS_BATCH_UPDATE');
            this.modalParams.close();
        }
        catch (err) {
            this.rootStore.notificationStore.error('LIST_LAYOUT.ERROR_BATCH_UPDATE');
        }
        this.disabled = false;
    }
}

export default PickTicketDetailNewFlowItemDetailsModalStore;
